import * as React from "react";
const SvgArrowRightOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="m10 17 5-5-5-5v10z" />
  </svg>
);
export default SvgArrowRightOutlined;
